<template>
  <v-menu
    v-model="dialog"
    :close-on-content-click="false"
    trasition="slide-y-transition"
    min-width="320px"
    left
    bottom
  >
    <template v-slot:activator="{ on }">
      <div v-show="showButton">
        <v-btn :class="buttonClass" dark v-on="on">
          <v-progress-circular
            color="white"
            size="20"
            width="3"
            indeterminate
            v-if="sendingEmail || sendingSms"
          ></v-progress-circular>
          <span v-else>{{ $t('components.paymentButton.payAction') }}</span>
        </v-btn>
        <slot name="tooltip"></slot>
      </div>
    </template>

    <v-card>
      <v-list vertical>
        <v-list-tile v-if="slipWarning">
          <v-list-tile-avatar :tile="false">
            <v-icon size="40">bexsicon-info</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title :class="slipWarning.titleClass">
              {{ slipWarning.title }}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ slipWarning.subTitle }}
            </v-list-tile-sub-title>
            <v-list-tile-action-text>
              <router-link
                v-if="slipWarning.actionTo"
                :to="slipWarning.actionTo"
                >{{ slipWarning.actionText }}</router-link
              >
            </v-list-tile-action-text>
          </v-list-tile-content>
        </v-list-tile>
        <template v-else>
          <v-list-tile @click="OnPaySlip(item)">
            <v-list-tile-avatar>
              <v-icon class="mr-2 colorGreen"
                >bexsicon-download</v-icon
              > </v-list-tile-avatar
            >{{ $t('components.paymentButton.downloadPaymentSlipAction') }}
          </v-list-tile>
          <v-list-tile v-if="item.barcode && item.ready" @click="CopyBarcode()">
            <v-list-tile-avatar>
              <v-icon class="mr-2 colorGreen">bexsicon-payment</v-icon>
            </v-list-tile-avatar>
            <span>{{ $t('components.paymentButton.payAction') }}</span>
            <input ref="barcode" id="barcode" v-model="item.barcode" />
          </v-list-tile>
          <v-list-tile
            v-if="
              emailEnabled && sendByEmail && item.documentCode && item.ready
            "
          >
            <v-layout column class="my-2">
              <text-field
                :label="$t('components.paymentButton.sendByEmailAction')"
                v-model="editedEmail"
                max-width="100%"
                type="email"
              ></text-field>
              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn
                  class="financial--background white--text"
                  text
                  @click="sendEmail(item, editedEmail)"
                >
                  <v-progress-circular
                    color="white"
                    size="24"
                    indeterminate
                    v-if="sendingEmail"
                  ></v-progress-circular>
                  <span v-else>{{ $t('actions.send') }}</span>
                </v-btn>
              </v-layout>
            </v-layout>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile
            v-if="smsEnabled && sendBySms && item.documentCode && item.ready"
            class="py-2"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{
                $t('components.paymentButton.sendBySmsAction')
              }}</v-list-tile-title>
              <v-list-tile-sub-title class="pl-2">
                <v-layout row class="height60">
                  <text-field
                    v-if="countryCodeVisible"
                    class="mr-2"
                    :label="$t('pages.profile.phone.countryCode')"
                    v-model="countryCode"
                    type="text"
                    maxWidth="60px"
                    maxlength="5"
                  ></text-field
                  >&nbsp;
                  <text-field
                    :label="$t('pages.profile.phone.areaCode')"
                    v-model="cellphone.areaCode"
                    @keyup.native="setFullCellphone(cellphone)"
                    type="tel"
                    maxWidth="60px"
                    maxlength="5"
                  ></text-field>
                  <text-field
                    :label="$t('pages.profile.phone.cellphone')"
                    v-model="cellphone.number"
                    @keyup.native="setFullCellphone(cellphone)"
                    maxlength="9"
                    type="tel"
                  ></text-field>
                </v-layout>
                <v-layout row>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="financial--background white--text"
                    text
                    :disabled="!fullCellphone"
                    @click="sendSms(item, fullCellphone)"
                  >
                    <v-progress-circular
                      color="white"
                      size="24"
                      indeterminate
                      v-if="sendingSms"
                    ></v-progress-circular>
                    <span v-else>{{ $t('actions.send') }}</span>
                  </v-btn>
                </v-layout>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import TextField from '@/components/fields/TextField';
import { CONFIG, APP } from '../../utils/constants';
import { snackbarColors } from '../../utils/enums';
export default {
  components: {
    TextField,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    email: {
      type: String,
    },
    cellphone: {
      type: Object,
    },
    sendByEmail: {
      type: Function,
      default: null,
    },
    countryCodeVisible: {
      type: Boolean,
      default: false,
    },
    sendBySms: {
      type: Function,
      default: null,
    },
    buttonClass: {
      type: String,
      required: true,
    },
  },
  computed: {
    slipWarning() {
      if (this.item.isPartialPaid) {
        return {
          title: this.$t('pages.paymentSlip.partialSlipWarningTitle'),
          titleClass: 'red--text',
          subTitle: this.$t('pages.paymentSlip.partialSlipWarningSubTitle'),
          actionText: this.$t('pages.paymentSlip.error.link'),
          actionTo: '/atendimento/solicitacao/nova',
        };
      }
      return null;
    },
    showButton() {
      return !!this.item.discountedValue || !!this.item.paymentTotal;
    },
    emailEnabled() {
      return this.$store.getters[CONFIG.GET_EMAIL_ENABLED] !== false;
    },
    smsEnabled() {
      return this.$store.getters[CONFIG.GET_SMS_ENABLED] !== false;
    },
  },
  data() {
    return {
      dialog: false,
      editedEmail: this.email,
      fullCellphone: '',
      sendingEmail: false,
      sendingSms: false,
    };
  },
  methods: {
    OnPaySlip() {
      this.$emit('openSlip', arguments);
      this.dialog = false;
    },
    CopyBarcode() {
      this.$refs['barcode'].select();
      this.$refs['barcode'].setSelectionRange(0, 99999);
      document.execCommand('copy');
      this.dialog = false;
      this.showSuccessToast(this.$t('responses.barcodeCopied'));
    },

    async sendEmail(item, email) {
      try {
        this.sendingEmail = true;
        let emailSent = false;
        this.dialog = false;
        if (this.sendByEmail) {
          const result = await this.sendByEmail(item, email);
          emailSent = result.emailSended;
        }

        if (emailSent) {
          this.showSuccessToast();
        } else {
          this.showErrorToast(this.$t('responses.sendEmailError'));
        }
      } catch (error) {
        this.showErrorToast(this.$t('responses.sendEmailError'));
      } finally {
        this.sendingEmail = false;
      }
    },
    async sendSms(item, fullCellphone) {
      try {
        this.sendingSms = true;
        let smsSent = false;
        this.dialog = false;
        if (this.sendBySms) {
          const result = await this.sendBySms(item, fullCellphone);
          smsSent = result.count;
        }

        if (smsSent) {
          this.showSuccessToast();
        } else {
          this.showErrorToast(this.$t('responses.sendSmsError'));
        }
      } catch (error) {
        this.showErrorToast(this.$t('responses.sendSmsError'));
      } finally {
        this.sendingSms = false;
      }
    },

    showSuccessToast(message) {
      const snackbarConfig = {
        text: message || this.$t('responses.paymentSlipSent'),
        color: snackbarColors.success,
      };
      this.$store.commit(APP.OPEN_SNACKBAR, snackbarConfig);
    },
    showErrorToast(text) {
      const snackbarConfig = {
        text,
        color: snackbarColors.error,
      };
      this.$store.commit(APP.OPEN_SNACKBAR, snackbarConfig);
    },
    setFullCellphone(value) {
      if (value) {
        this.fullCellphone =
          (value.areaCode + value.number).length >= 10
            ? value.countryCode + value.areaCode + value.number
            : null;
      } else {
        this.fullCellphone = null;
      }
    },
  },
  watch: {
    cellphone: {
      deep: true,
      immediate: true,
      handler: 'setFullCellphone',
    },
  },
};
</script>

<style lang="scss" scoped>
>>> .v-list__tile {
  font-size: 14px !important;
  min-height: 40px !important;
  height: auto !important;
}
#barcode {
  width: 10px;
  opacity: 0;
}

.phone-code {
  max-width: 60px;
}

.colorGreen {
  color: #4bb629 !important;
}

.height60 {
  height: 60px;
}

.payment-slip__pay-btn {
  flex: 0.2;
  z-index: 1;
  height: 25px;
  min-width: 60px;
  font-size: 12px;
  margin: 0;
  padding: 5px 14px !important;
  border-radius: 5px;
  text-decoration: none;
  color: #fff;
  text-align: center;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/financial/PaymentButton.vue